export default "__VITE_ASSET__BuYsy_Qu__"